import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionpoint() {
  return (
    <section className="scope_rev p-100 text_white bg_purple_color">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Expectations of TekRevol's
              <span style={{ color: "#E8E751" }}> In-House Project</span>
            </h2>
            <div className="scope_content">
              <p>
                TekRevol envisions Rev Coin as a revolutionary solution that
                transforms employee benefits and reinforces the company's
                commitment to its workforce.
              </p>
              <p>
                The project aims to improve employee engagement and fulfilment
                through the delivery of tangible incentives and transparent
                ownership enabled by blockchain technology.
              </p>
              <p>
                Rev Coin is expected to serve as a valuable asset that empowers
                employees, nurtures a sense of ownership and loyalty towards the
                organization.
              </p>
              <p>
                The unified integration of Rev Coin across various platforms is
                anticipated to provide employees a user-friendly experience,
                allowing easy access and management of their rewards.
              </p>
              <p>
                The unified integration of Rev Coin across various platforms is
                anticipated to provide employees a user-friendly experience,
                allowing easy access and management of their rewards.
              </p>
              <p>
                TekRevol aims to develop a positive work culture by using Rev
                Coin as a symbol of the company's dedication to employee
                welfare.
              </p>
              <p>
                By implementing this groundbreaking solution, the organization
                seeks to encourage long-term commitment and build strong
                employee relationships.
              </p>
              <p>
                Moreover, TekRevol expects that Rev Coin's implementation will
                subsidize to a streamlined and efficient employee benefits
                management system, removing complexities and improving the
                overall experience for employees..
              </p>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/rev-coin/expectation_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={652}
                height={864}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionpoint;
